import { createElement } from 'react'
import * as PropTypes from 'prop-types'
import { DEFAULT_HELP_CENTER_URL } from '../../utils/getHelpCenterLinks'

const HelpCenterLink = ({ tagName, children, article, ...props }) => {
  return createElement(
    tagName || 'a',
    {
      target: '_blank',
      href: DEFAULT_HELP_CENTER_URL,
      ...props
    },
    ...(Array.isArray(children) ? children : [children])
  )
}

HelpCenterLink.propTypes = {
  tagName: PropTypes.elementType,
  article: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
}

export default HelpCenterLink
